import React, { useEffect } from 'react';
import './Services.css';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { Link } from 'react-router-dom';

const services = [
    {
        id: '1',
        title: 'Application Development',
        image: 'https://i.postimg.cc/HWbMcQDD/unsplash-SYTO3xs06f-U.png',
        description: 'Ultimate destination for comprehensive Full Stack Development solutions. With a robust suite of services tailored to your needs, we specialize in crafting cutting-edge digital experiences.',
    },
    {
        id: '2',
        title: 'Responsive Website Development',
        image: 'https://i.postimg.cc/SKVTpwdd/unsplash-SYTO3xs06f-U-1.png',
        description: 'Elevate your online presence with visually stunning and highly functional websites optimized for viewing on any device, ensuring an exceptional user experience regardless of screen size or orientation.',
    },
    {
        id: '3',
        title: 'UI/UX Design Service',
        image: 'https://i.postimg.cc/xC46XMWb/unsplash-SYTO3xs06f-U-2.png',
        description: 'Put user experience at the forefront of your digital products with our expert UI/UX design services. We blend aesthetics with functionality to create intuitive and engaging interfaces that resonate with your target audience.',
    },
    {
        id: '4',
        title: 'Hosting Solutions',
        image: 'https://i.postimg.cc/3ryTnBrV/unsplash-SYTO3xs06f-U-3.png',
        description: 'Secure, reliable, and scalable hosting solutions tailored to your specific requirements. Whether you need shared hosting, dedicated servers, cloud hosting, or managed hosting services.',
    },
    {
        id: '5',
        title: 'CMS Maintenance',
        image: 'https://i.postimg.cc/tCWHH4xz/unsplash-SYTO3xs06f-U-4.png',
        description: 'Keep your content management system (CMS) running smoothly with our comprehensive maintenance services. From regular updates and security patches to content management and performance optimization.',
    },
    {
        id: '6',
        title: 'Digital Marketing',
        image: 'https://i.postimg.cc/T3cMpNQL/unsplash-SYTO3xs06f-U-5.png',
        description: 'Amplify your online presence and reach your target audience with our strategic digital marketing solutions. From search engine optimization (SEO) and pay-per-click (PPC) advertising to social media marketing and content creation.',
    },
];

function Services() {

    const styles = {
        whatsappIcon: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            backgroundColor: '#25D366',
            color: 'white',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '30px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            zIndex: 1000,
        }
    }

    useEffect(() => {
        if (window.particlesJS) {
            window.particlesJS('animated-background', {
                particles: {
                    number: {
                        value: 100,
                        density: {
                            enable: true,
                            value_area: 800
                        }
                    },
                    color: {
                        value: '#77a3a3'
                    },
                    shape: {
                        type: 'circle',
                        stroke: {
                            width: 0,
                            color: '#000000'
                        },
                        polygon: {
                            nb_sides: 5
                        }
                    },
                    opacity: {
                        value: 0.5,
                        random: false,
                        anim: {
                            enable: false,
                            speed: 1,
                            opacity_min: 0.1,
                            sync: false
                        }
                    },
                    size: {
                        value: 3,
                        random: true,
                        anim: {
                            enable: false,
                            speed: 40,
                            size_min: 0.1,
                            sync: false
                        }
                    },
                    line_linked: {
                        enable: true,
                        distance: 150,
                        color: '#77a3a3',
                        opacity: 0.4,
                        width: 1
                    },
                    move: {
                        enable: true,
                        speed: 6,
                        direction: 'none',
                        random: false,
                        straight: false,
                        out_mode: 'out',
                        bounce: false,
                        attract: {
                            enable: false,
                            rotateX: 600,
                            rotateY: 1200
                        }
                    }
                },
                interactivity: {
                    detect_on: 'canvas',
                    events: {
                        onhover: {
                            enable: true,
                            mode: 'repulse'
                        },
                        onclick: {
                            enable: true,
                            mode: 'push'
                        },
                        resize: true
                    },
                    modes: {
                        grab: {
                            distance: 400,
                            line_linked: {
                                opacity: 1
                            }
                        },
                        bubble: {
                            distance: 400,
                            size: 40,
                            duration: 2,
                            opacity: 8,
                            speed: 3
                        },
                        repulse: {
                            distance: 200,
                            duration: 0.4
                        },
                        push: {
                            particles_nb: 4
                        },
                        remove: {
                            particles_nb: 2
                        }
                    }
                },
                retina_detect: true
            });
        }
    }, []);

    return (
        <div>
            <Header />
            <div id="animated-background"></div>
            <div className='bg-black' style={{ marginTop: '68px' }}>
                <div >
                    <img style={{ zIndex: '2' }} className='serviceimage' src="https://i.postimg.cc/02m50Myj/close-up-man-robotic-process-automation-concept-2.png" alt="services" />
                    <p className='servicehead'>SERVICES</p>
                </div>
                <div className='parag'>
                    <p className='text-white text-center p-5 ot'>Ultimate destination for comprehensive Full Stack Development solutions. With a robust suite of services tailored to your needs, we specialize in crafting cutting-edge digital experiences.</p>
                </div>
                <div className='full'>
                    <h1 className='text-white p-5'>
                        <b className='at'>Our Full-Stack <br /> Development Services</b>
                    </h1>
                    <div className='p-5 moil' style={{ zIndex: '2' }}>
                        <div className='development-row p-3'>
                            <div className='development'>
                                <img src="https://i.postimg.cc/BbgwfLbT/Frame-52.png" alt="Python" />
                                <h4 className='text-white'>Python</h4>
                                <p className='text-white p-3 ot'>Harness the power of Python's simplicity and versatility for robust backend development, data analysis, and AI applications.</p>
                            </div>
                            <div className='development'>
                                <img src="https://i.postimg.cc/63G7ygvq/Frame-53.png" alt="React" />
                                <h4 className='text-white'>React</h4>
                                <p className='text-white p-3 ot'>Create interactive and reusable UI components with React, a JavaScript library renowned for its efficiency and flexibility in building single-page applications.</p>
                            </div>
                            <div className='development'>
                                <img src="https://i.postimg.cc/cCSJ6HWk/Frame-54.png" alt="JavaScript" />
                                <h4 className='text-white'>JavaScript</h4>
                                <p className='text-white p-3 ot'>Enhance user interactions and build dynamic web applications with JavaScript, the backbone of modern web development.</p>
                            </div>
                        </div>
                        <div className='development-row p-3'>
                            <div className='development'>
                                <img src="https://i.postimg.cc/vmnM9s3J/Frame-55-3.png" alt="Flutter" />
                                <h4 className='text-white'>Flutter</h4>
                                <p className='text-white p-3 ot'>Craft beautiful native interfaces for mobile, web, and desktop from a single codebase with Flutter, Google's UI toolkit for building natively compiled applications.</p>
                            </div>
                            <div className='development'>
                                <img src="https://i.postimg.cc/tTtjSz0D/Frame-56.png" alt="MongoDB" />
                                <h4 className='text-white'>MongoDB</h4>
                                <p className='text-white p-3 ot'>Embrace the flexibility and scalability of MongoDB, a NoSQL database, for efficient storage and retrieval of structured and unstructured data.</p>
                            </div>
                            <div className='development'>
                                <img src="https://i.postimg.cc/wTbdGvPK/Frame-57.png" alt="NodeJS" />
                                <h4 className='text-white'>NodeJS</h4>
                                <p className='text-white p-3 ot'>Empower your applications with real-time, event-driven capabilities using Node.js, a JavaScript runtime built on Chrome's V8 engine, ideal for building scalable network applications.</p>
                            </div>
                        </div>
                        <div className='development-row p-3'>
                            <div className='development'>
                                <img src="https://i.postimg.cc/XYz7dx3C/Frame-55.png" alt="Java" />
                                <h4 className='text-white'>Java</h4>
                                <p className='text-white p-3 ot'>Leverage the robustness and platform independence of Java for enterprise-grade backend development, Android app development, and more.</p>
                            </div>

                            <div className='development'>
                                <img src="https://i.postimg.cc/TYkRvQK4/Frame-55-2.png" alt="Angular" />
                                <h4 className='text-white'>Angular</h4>
                                <p className='text-white p-3 ot'>Develop dynamic and scalable web applications with Angular, a TypeScript-based framework backed by Google, offering robust features for frontend development.</p>
                            </div>
                            <div className='development'>
                                <img style={{height:"90px",width:"130px"}} src="https://i.postimg.cc/Y2GgX1HY/png-transparent-figma-app-logo-tech-companies-removebg-preview.png" alt="Figma" />
                                <h4 className='text-white'>Figma</h4>
                                <p className='text-white p-3 ot'>Design and prototype user interfaces collaboratively with Figma, a powerful tool for UI/UX design that supports real-time collaboration and feedback.</p>
                            </div>
                        </div>
                        <div className='development-row p-3'>
                            <div className='development'>
                                <img style={{height:"90px",width:"90px"}} src="https://i.postimg.cc/1zzhPRRh/aws-logo.png" alt="AWS" />
                                <h4 className='text-white'>AWS</h4>
                                <p className='text-white p-3 ot'>Utilize Amazon Web Services for scalable cloud computing solutions, storage, and other services to support and manage your applications efficiently.</p>
                            </div>
                            <div className='development'>
                                <img  style={{height:"90px",width:"90px"}} src="https://i.postimg.cc/g0XBcxhh/My-SQL-Logo.png" alt="MySQL" />
                                <h4 className='text-white'>MySQL</h4>
                                <p className='text-white p-3 ot'>Leverage MySQL, a popular relational database management system, for robust and reliable data storage and retrieval with SQL-based querying.</p>
                            </div>
                            <div className='development'>
                                <img style={{height:"90px",width:"90px"}} src="https://i.postimg.cc/yYBSP2Y3/html-removebg-preview.png" alt="HTML5" />
                                <h4 className='text-white'>HTML5</h4>
                                <p className='text-white p-3 ot'>Build modern, interactive web pages with HTML5, the latest standard for HTML, offering advanced features for multimedia and rich content.</p>
                            </div>
                        </div>
                        <div className='development-row p-3'>
                            
                        </div>
                    </div>
                </div>

                <div className="prod">
                    <h1 className="text-white p-5"><b>Product Development Services</b></h1>
                    <div className="cards-container">
                        {services.map(service => (
                            <div className="card" key={service.id}>
                                <img src={service.image} alt={service.title} />
                                <div className="overlay">
                                    <h1><b>{service.title}</b></h1>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
            <div style={styles.whatsappIcon}>
                <Link to={"https://wa.me/919778564277"} style={{ color: "white" }}>
                    <a target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-whatsapp"></i>
                    </a>
                </Link>
            </div>
        </div>
    );
}

export default Services;
